import React, { useEffect } from "react";
// 5888
import { Field, useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
//5889

import { TextField } from "formik-mui";
import InputAdornment from "@mui/material/InputAdornment";
import CodeIcon from "@mui/icons-material/Code";
import propTypes from "prop-types";

import BrandAutoComplete from "../MaterialComponents/BrandAutoComplete";
import MoreInfo from "../MaterialComponents/MoreInfo";

const RichWebPageSetup = ({ brandTypes }) => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    setFieldValue(
      "external_step_name",
      `${values.name || ""}-${values.external_step_url || ""}`
    );
  }, [values.external_step_url, values.name]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            Please enter the website you would like us to test your ad on
          </Typography>
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <Field
            fullWidth
            name="incontext_primary_site"
            component={TextField}
            label="Test page URL"
            variant="filled"
          />
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="The test page is where your test rich media will be displayed"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            The distraction site you would like us to test your comparisons with
          </Typography>
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <Field
            fullWidth
            name="incontext_distraction_site"
            component={TextField}
            label="Distraction page URL"
            variant="filled"
          />
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup={`The distraction page features other ads and increases realism for the respondents but isn't part of the dataset`}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            The skin&apos;s code that you would like us to test
          </Typography>
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <Field
            fullWidth
            name="stim_script"
            component={TextField}
            label="Ad script"
            variant="filled"
            multiline
            InputProps={{
              startAdornment: (
                <InputAdornment variant="standard" position="start">
                  <CodeIcon
                    fontSize="small"
                    style={{ color: "rgba(0, 0, 0, 0.54)" }}
                  />
                </InputAdornment>
              ),
            }}
          />
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="The ad script is the javascript which inserts your rich media into the webpage"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            And then, finally, please choose your brand name and we are good to
            go.
          </Typography>
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <BrandAutoComplete brandTypes={brandTypes} />
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="The brand name of the company featured in your test ad "
          />
        </Grid>
      </Grid>
    </>
  );
};

RichWebPageSetup.propTypes = {
  brandTypes: propTypes.object,
};

export default RichWebPageSetup;
